import LoginSvc from '@/services/login';
// import AnalysisSvc from '@/services/analysis';

export default {
  data() {
    return {
      code: '',
      sended: !1,
      count: 60,
    };
  },
  computed: {
    codeError() {
      if (!this.getError && !this.validators) return '';
      return this.getError(this.validators.code, {
        required: '请输入验证码',
        number: '验证码应为数字',
      });
    },
    verifyInvalid() {
      return this.sended ||
      (this.validators && this.validators.phone && !this.validators.phone.$valid);
    },
    verifyTxt() {
      return this.sended ? `已发送（${this.count}）` : '获取验证码';
    },
    trackEventOrigin() {
      switch (this.$options.name) {
        case 'Login': return 'web_login';
        case 'Reset': return 'web_reset';
        case 'Register': return 'web_register';
        case 'Bind': return 'web_bind';
        default: return '';
      }
    },
  },
  mounted() {
    const self = this;
    // eslint-disable-next-line
    new YpRiddler({
      expired: 2,
      mode: 'dialog',
      winWidth: 360,
      lang: 'zh-cn', // 界面语言, 目前支持: 中文简体 zh-cn, 英语 en
      container: document.getElementById('captchaBox'),
      appId: '3b13cf79ee5c47bebd0613030a15e440',
      version: 'v1',
      onError(param) {
        if (param.code === 429) {
          // eslint-disable-next-line
          alert('请求过于频繁，请稍后再试！');
          return;
        }
          // 异常回调
          // eslint-disable-next-line
        alert('验证服务异常');
      },
      onSuccess(validInfo, close) {
        // 成功回调
        self.getVerifyCode(validInfo);
        close();
      },
      onFail(code, msg, retry) {
        // 失败回调
        retry();
      },
      beforeStart(next) {
        next();
      },
      onExit() {
        // 退出验证 （仅限dialog模式有效）
      },
    });
  },
  methods: {
    getVerifyCode(validInfo) {
      if (this.verifyInvalid || !this.phone || this.sended) return !1;

      this.sended = !0;
      this.counter();

      return LoginSvc.getVerifyCode({}, {
        area_code: this.area,
        phone: this.phone,
        authenticate: validInfo.authenticate,
        token: validInfo.token,
      })
        .then((sucuessful) => {
          // eslint-disable-next-line
          if (!sucuessful) alert('获取验证码失败，请重试。');
        });
    },
    // track(sucessful) {
    //   if (!this.trackEventOrigin) return;
    //   AnalysisSvc.track('GetVerifyCode', {
    //     event_origin: this.trackEventOrigin,
    //     is_success: !!sucessful,
    //   });
    // },
    counter() {
      if (this.count > 0) {
        this.count -= 1;
        this.timer = setTimeout(this.counter, 1000);
      } else {
        this.count = 60;
        this.sended = !1;
        this.timer = null;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/verify.js